import React from "react";
import { t } from "../../i18n/translations";

const ValueProposition = () => {
  const stats = [
    { value: t("value.stat1"), label: t("value.stat1Label"), color: "text-red-600" },
    { value: t("value.stat2"), label: t("value.stat2Label"), color: "text-orange-600" },
    { value: t("value.stat3"), label: t("value.stat3Label"), color: "text-emerald-600" },
  ];

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-700 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wider mb-4 border border-red-100">
              {t("value.badge")}
            </div>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mb-6 leading-tight">
              {t("value.title")}
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-8">{t("value.subtitle")}</p>

            <div className="space-y-4">
              {stats.map((stat, i) => (
                <div key={i} className="flex items-center gap-4 bg-slate-50 rounded-lg p-4 border border-slate-100">
                  <div className={`text-3xl font-extrabold ${stat.color} min-w-[120px]`}>{stat.value}</div>
                  <div className="text-sm text-slate-600 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="bg-red-600 rounded-lg p-8 text-white relative overflow-hidden">
              <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" />

              <div className="relative">
                <h3 className="text-2xl font-extrabold mb-4">The Golden Hour</h3>
                <p className="text-white/90 leading-relaxed mb-6">
                  Medical research shows that 50% of accident fatalities could be prevented with timely first aid within
                  the first 60 minutes. EmergencyQR ensures that critical medical information reaches first responders
                  instantly.
                </p>

                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-white/15 rounded-lg p-4 border border-white/20">
                    <p className="text-3xl font-extrabold">60</p>
                    <p className="text-sm text-white/80 font-medium">Minutes to save a life</p>
                  </div>
                  <div className="bg-white/15 rounded-lg p-4 border border-white/20">
                    <p className="text-3xl font-extrabold">1.5L+</p>
                    <p className="text-sm text-white/80 font-medium">Annual road deaths</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
